import EventEmitter from 'eventemitter3'

export const hospitalSelectEvent = new EventEmitter()

export function reloadHospitalSelect() {
    hospitalSelectEvent.emit('RELOAD')
}
